import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { loginUrlFor } from '../utils/loginRedirect';

// roles: optional array — if provided, user must belong to at least one
const ProtectedRoute = ({ children, roles }) => {
  const { user, loading, hasRole } = useAuth();
  const location = useLocation();

  if (loading) return null;
  // Remember the page so login can return to it (utils/loginRedirect.js).
  if (!user) return <Navigate to={loginUrlFor(location.pathname + location.search)} replace />;
  if (roles && !hasRole(...roles)) return <Navigate to="/" replace />;

  return children;
};

export default ProtectedRoute;
